// src/components/NavBar/index.js
import NavBar from './NavBar';
export default NavBar;